import { AppRoute } from '@agentselly/immodossier-shared';
import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { Button } from '~/components/ui/Button';
import { useTranslate } from '@tolgee/react';
import { useEffect, useState } from 'react';
import { useRouter, type NotFoundRouteProps } from '@tanstack/react-router';
import { useClerk } from '@clerk/clerk-react';
import { LoadingSpinner } from '~/components/global/LoadingSpinner';

export function NotFoundWidget(_props?: NotFoundRouteProps) {
  const { t } = useTranslate();
  const router = useRouter();
  const { redirectToSignIn } = useClerk();
  const [
    retryCount,
    setRetryCount,
  ] = useState(0);
  const [
    showError,
    setShowError,
  ] = useState(false);

  useEffect(() => {
    // Note: TanStack Router doesn't pass error to notFoundComponent
    // This logic is kept for backwards compatibility but may not execute
    const is403 = false;

    if (is403) {
      redirectToSignIn({
        redirectUrl: window.location.pathname + window.location.search,
      });
      return;
    }

    if (retryCount < 3) {
      const timer = setTimeout(() => {
        setRetryCount((prev) => prev + 1);
        router.invalidate();
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      setShowError(true);
    }
  }, [
    retryCount,
    router,
    redirectToSignIn,
  ]);

  if (!showError && retryCount < 3) {
    return (
      <WrapperWidget>
        <div className="min-h-32 flex items-center justify-center">
          <LoadingSpinner />
        </div>
      </WrapperWidget>
    );
  }

  return (
    <WrapperWidget>
      <EmptyState
        title={t('notfound_title')}
        description={t('notfound_text')}
        actions={
          <a href={AppRoute.ROOT}>
            <Button showArrow>{t('notfound_link')}</Button>
          </a>
        }
      />
    </WrapperWidget>
  );
}
